import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ExclamationCircleFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.666687 8.00002C0.666687 4.33335 2.50002 0.666687 8.00002 0.666687C13.5 0.666687 15.3334 4.33335 15.3334 8.00002C15.3334 11.6667 13.5 15.3334 8.00002 15.3334C2.50002 15.3334 0.666687 11.6667 0.666687 8.00002ZM7.40002 9.00002L7.40002 4.00002H8.60002V9.00002H7.40002ZM8.00002 10C8.46026 10 8.83335 10.3731 8.83335 10.8334C8.83335 11.2936 8.46026 11.6667 8.00002 11.6667C7.53978 11.6667 7.16669 11.2936 7.16669 10.8334C7.16669 10.3731 7.53978 10 8.00002 10Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const ExclamationCircleFilledSize16 = hoc(forwardRef(ExclamationCircleFilledSize16Component), 'ExclamationCircleFilledSize16');

export { ExclamationCircleFilledSize16 as default };
//# sourceMappingURL=ExclamationCircleFilledSize16.js.map
